module.exports = __webpack_public_path__ + "media/landing_page/lp4-hero-mobile-02-c8657547.jpg";